import { createAsyncThunk } from "@reduxjs/toolkit";
import { otp_verification } from "../../../networking/urlEndPoints";

import { fetchPharmacyDetails } from "../dispense/getPharmacyDetail";
import { fetchAllPharmacistList } from "../../slices/supervisor/pendingCounselling";
import { authSelectedPharmacist } from "./selectedPharmacistID";

import Axios from "../../../networking/interceptor";
import Cookies from "js-cookie";
import { getCookieOptions } from "../../../utils/helper/security";

import * as routeName from '../../../routes/routeName'

export const verifyDriverOTP = createAsyncThunk('verifyDriverOTP', async ({ reqData,
    navigate,
    dispatch,
    setOpenPharmacistModal,
    defaultPharmacist,
    flexiUser,
    hcpUser
}, { rejectWithValue }) => {

    try {
        const pharmacistUser = defaultPharmacist?.[0]?.driver_pharmacist_user
        const pharmacistId = pharmacistUser?.id ?? null
        const isPharmacist = pharmacistUser?.type === 'pharmacist'

        const { pharmacy_id, otp } = reqData
        const response = await Axios.post(otp_verification,
            {
                pharmacy_id: pharmacy_id,
                otp: otp
            }
        );
        const data = response.data;
        
        // const linkedOtpResponse = await dispatch(fetchPharmacyHasLinkedOtp({ pharmacyId: pharmacy_id }));
        // const linkedStatus = linkedOtpResponse?.payload?.data

        const isSuccess = response?.status === 200 || response?.status === 201;

        // Ensure flexiUser is properly evaluated as boolean
        const isFlexiUser = flexiUser === true || flexiUser === 'true' || flexiUser === 1;

        function goToDashboard() {
            Cookies.set('verified', 1, getCookieOptions({ expiresHours: 11 }));
            reqData.dispatch(fetchPharmacyDetails(reqData.pharmacy_id));

            // if (isFlexiUser) {
            //     navigate(routeName.flexi_delivery);
            // } else {
            //     navigate(routeName.DASHBOARD_PHARMACY);
            // }

            if (hcpUser === 0 && isFlexiUser) navigate(routeName.DASHBOARD_PHARMACY);
            else if (hcpUser === 0) navigate(routeName.ADD_VITALS);
            else if (isFlexiUser) navigate(routeName.flexi_delivery);
            else navigate(routeName.DASHBOARD_PHARMACY);
        }

        function openRoutePickerModal() {
            Cookies.set('verified', 1, getCookieOptions({ expiresHours: 11 }));
            reqData.dispatch(fetchPharmacyDetails(reqData.pharmacy_id));

            if (pharmacistId) {
                dispatch(authSelectedPharmacist(pharmacistId));
            }

            typeof setOpenPharmacistModal === 'function' && setOpenPharmacistModal(true);
        }

        // Pharmacists should skip pharmacist selection and open route picking on the OTP page.
        if (isSuccess && isPharmacist) {
            return openRoutePickerModal();
        }

        // Driver: show pharmacist selection modal
        // if (linkedStatus?.active === 1 && isSuccess) {
        if (isSuccess) {
            dispatch(fetchAllPharmacistList({ pharmacyId: pharmacy_id }));
            typeof setOpenPharmacistModal === 'function' && setOpenPharmacistModal(true);
            return;
        }

        goToDashboard();

        return data

    } catch (error) {
        Cookies.set('verified', 0, getCookieOptions())
        return rejectWithValue(error.response)
    }
});
